export default (pages) => [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: pages.dashboardPage,
    redirect: {
      name: 'holdings-dashboard'
    },
    children: [
      {
        path: '',
        name: 'holdings-dashboard',
        component: pages.holdingsDashboard,
        meta: {
          style: {
            'padding-bottom': 0
          },
          pos: 1
        }
      },
      {
        path: 'contracts',
        name: 'dashboard-contracts',
        component: pages.dashboardContracts,
        meta: {
          pos: 2
        }
      }
    ]
  },
  {
    path: 'loans-dashboard',
    name: 'loans',
    component: pages.dashboardPage,
    redirect: {
      name: 'loans-dashboard'
    },
    children: [
      {
        path: '',
        name: 'loans-dashboard',
        component: pages.loansDashboard,
        meta: {
          style: {
            'padding-bottom': 0
          },
          pos: 1
        }
      },
      {
        path: 'contracts',
        name: 'dashboard-loans-contracts',
        component: pages.dashboardLoansContracts,
        meta: {
          pos: 2
        }
      }
    ]
  },
  {
    path: 'contract/:contractId',
    name: 'contract',
    component: pages.contractPage,
    redirect: {name: 'contract-overview'},
    props: true,
    children: [
      {
        path: 'overview',
        name: 'contract-overview',
        component: pages.contractOverview,
        props: true,
        meta: { pos: 1 }
      },
      {
        path: 'project',
        name: 'contract-project',
        component: pages.contractProject,
        meta: { pos: 2 }
      },
      {
        path: 'allocation',
        name: 'contract-allocation',
        component: pages.contractAllocation,
        meta: { pos: 3 }
      },
      {
        path: 'investments',
        name: 'contract-investments',
        component: pages.contractInvestments,
        meta: { pos: 4 }
      },
      {
        path: 'settings',
        name: 'contract-settings',
        component: pages.contractSettings,
        props: true,
        meta: { pos: 5 }
      },
      // @todo It seems a deprecated page
      // Need to delete all related component files
      {
        path: 'details',
        name: 'contract-details',
        component: pages.contractDetails,
        meta: { pos: 2 }
      },
      {
        path: 'documents',
        name: 'contract-documents',
        component: pages.contractDocuments,
        meta: { pos: 3 }
      },
      {
        path: 'informations',
        name: 'contract-informations',
        component: pages.contractInformations,
        meta: { pos: 2 }
      },
      {
        path: 'info-needed',
        name: 'contract-info-needed',
        component: pages.contractInfoNeeded,
        meta: { pos: 5 }
      }
    ]
  },
  {
    path: 'contract-realestate/:contractId',
    name: 'contract-realestate',
    component: pages.realestatePage,
    redirect: {name: 'contract-realestate-overview'},
    props: true,
    children: [
      {
        path: 'overview',
        name: 'contract-realestate-overview',
        component: pages.contractOverview,
        props: true,
        meta: { pos: 1 }
      },
      {
        path: 'settings',
        name: 'contract-realestate-settings',
        component: pages.realEstateSettings,
        props: true,
        meta: { pos: 2 }
      }
    ]
  },
  {
    path: 'contract/:contractId/analyse',
    name: 'analyse',
    component: pages.analysePage,
    redirect: from => {
      return {name: 'analyse-allocation', params: {contractId: from.params.contractId, substep: 1}}
    },
    props: true,
    children: [
      {
        path: 'allocation/:substep',
        name: 'analyse-allocation',
        props: true,
        component: pages.analyseAllocation
      },
      {
        path: 'performances/:substep',
        name: 'analyse-performances',
        props: true,
        component: pages.analysePerf
      },
      {
        path: 'risk/:substep',
        name: 'analyse-risk',
        props: true,
        component: pages.analyseRisk
      },
      {
        path: 'fees/:substep',
        name: 'analyse-fees',
        props: true,
        component: pages.analyseFees
      },
      {
        path: 'advices/:substep',
        name: 'analyse-advices',
        props: true,
        component: pages.analyseAdvices
      }
    ]
  },
  {
    path: 'contract/:contractId/arbitration',
    name: 'arbitration',
    component: pages.arbitrationPage,
    redirect: from => {
      return {name: 'arbitration-start', params: {contractId: from.params.contractId}}
    },
    props: true,
    children: [
      {
        path: 'start',
        name: 'arbitration-start',
        props: true,
        component: pages.arbitrationStart
      },
      {
        path: 'market',
        name: 'arbitration-market',
        props: true,
        component: pages.arbitrationMarket
      },
      {
        path: 'optimize',
        name: 'arbitration-optimize',
        props: true,
        component: pages.arbitrationOptimize
      }
    ]
  },
  {
    path: 'contract/:contractId/reco',
    name: 'reco',
    redirect: to => ({name: 'analyse-advices', params: { contractId: to.params.contractId, substep: 1 }})
  },
  {
    path: 'contract/:contractId/fund/:isin',
    name: 'fund',
    component: pages.fundPage,
    props: true
  },
  {
    path: 'user',
    name: 'user',
    component: pages.userPage,
    redirect: {name: 'user-infos'},
    children: [
      {
        path: 'infos',
        name: 'user-infos',
        component: pages.userInfos,
        props: true,
        meta: { pos: 1 }
      },
      {
        path: 'holdings',
        name: 'user-holdings',
        component: pages.userHoldings,
        meta: {
          offset: -130,
          pos: 2
        }
      },
      // {
      //   path: 'advisor',
      //   name: 'user-advisor',
      //   component: pages.userAdvisor,
      //   meta: {
      //     offset: -130,
      //     pos: 3
      //   }
      // },
      {
        path: 'notifications',
        name: 'user-notifications',
        component: pages.userNotifications,
        meta: { pos: 4 }
      },
      {
        path: 'profile',
        name: 'user-profile',
        component: pages.userProfile,
        props: true,
        meta: { pos: 5 }
      },
      {
        path: 'payment',
        name: 'user-payment',
        component: pages.userPayment,
        meta: { pos: 6 }
      }
    ]
  },
  {
    path: 'account/webauth',
    name: 'account-webauth-redirection',
    component: pages.accountWebauthRedirect,
    props: (route) => ({
      idConnection: route.query.id_connection,
      state: route.query.state,
      error: route.query.error,
      errorDescription: route.query.error_description
    })
  },
  {
    path: 'accounts/new',
    component: pages.accountsAdd,
    children: [
      {
        path: '',
        name: 'accounts-new-index',
        component: pages.accountsAddIndex,
        props: true,
        meta: {
          hideMenu: false,
          style: {
            'padding-bottom': 0
          }
        }
      },
      {
        path: ':bankId',
        name: 'accounts-new-form',
        component: pages.accountsAddForm,
        props: true,
        meta: {
          hideMenu: true,
          style: {
            'padding-bottom': 0
          }
        }
      },
      {
        path: ':bankId/selection',
        name: 'accounts-new-list',
        component: pages.accountsNewList,
        props: true,
        meta: {
          hideMenu: true,
          style: {
            'padding-bottom': 0
          }
        }
      },
      {
        path: 'real-estate',
        name: 'real-estate-form-add-new',
        component: pages.realEstateFormAddNew,
        props: true,
        meta: {
          hideMenu: true,
          style: {
            'padding-bottom': 0
          }
        }
      },
      {
        path: 'evaluate',
        name: 'real-estate-evaluate',
        component: pages.realEstateEvaluate,
        props: true,
        meta: {
          hideMenu: true,
          style: {
            'padding-bottom': 0
          }
        }
      }
    ]
  },
  {
    path: 'accounts/update/:accountId/credentials',
    component: pages.accountsUpdateCredentials,
    name: 'accounts-update-credentials',
    meta: {
      hideMenu: false,
      style: {
        'padding-bottom': 0
      }
    }
  },
  {
    path: 'club',
    name: 'club',
    component: pages.clubLayout,
    redirect: {
      name: 'club-dashboard'
    },
    children: [
      {
        path: 'landing',
        name: 'club-landing',
        component: pages.ClubLanding
      },
      {
        path: 'portfolios-selection',
        name: 'club-portfolios-selection',
        component: pages.ClubPortfoliosSelection
      },
      {
        path: 'verify-info',
        name: 'club-verify-info',
        component: pages.ClubVerifyInfo
      },
      {
        path: 'price-selection',
        name: 'club-price-selection',
        component: pages.clubPriceSelection
      },
      {
        path: 'subscribe',
        name: 'club-subscribe',
        component: pages.clubSubscription
      },
      {
        path: 'waiting-payment-infos',
        name: 'club-waiting-payment-infos',
        component: pages.ClubPaymentInfos
      },
      {
        path: 'waiting-advisor',
        name: 'club-waiting-advisor',
        component: pages.ClubWaitingAdvisor
      },
      {
        path: 'dashboard',
        name: 'club-dashboard',
        component: pages.clubDashboard,
        redirect: { name: 'club-dashboard-portfolios' },
        props: true,
        children: [
          {
            path: 'portfolios',
            name: 'club-dashboard-portfolios',
            component: pages.ClubPortfolios,
            meta: {
              pos: 1
            }
          },
          {
            path: 'settings',
            name: 'club-dashboard-settings',
            component: pages.ClubSettings,
            meta: {
              pos: 2
            }
          }
        ]
      },
      {
        path: 'unsubscribe',
        name: 'club-unsubscribe',
        component: pages.ClubUnsubscribe
      },
      {
        path: 'survey',
        name: 'club-survey',
        component: pages.ClubExitSurvey
      }
    ]
  }
]
